<template>
  <div class="header-right">
    <div class="header-right__auth" v-if="isAuthenticated">
      <b-dropdown
        class="auth-dropdown"
        toggle-class="auth-dropdown__button"
        menu-class="auth-dropdown__menu"
        no-caret
        right
      >
        <template #button-content>
          <span class="avatar">{{ initials }}</span>
        </template>

        <b-dropdown-text class="auth-dropdown__header">
          <div class="auth-dropdown__header-row">
            <span class="auth-dropdown__avatar-lg">{{ initials }}</span>
            <span class="auth-dropdown__info">
              <span class="auth-dropdown__email" :title="email">{{ email }}</span>
              <span class="auth-dropdown__role">{{ roleLabel }}</span>
            </span>
          </div>
        </b-dropdown-text>
        <b-dropdown-divider />

        <b-dropdown-item v-if="isClinic" :to="{ name: 'clinic-dashboard' }" v-tx="'HeaderDashboard'">{{ t('dashboard') }}</b-dropdown-item>
        <b-dropdown-item v-if="isClinic" :to="{ name: 'candidates' }" v-tx="'HeaderCandidates'">{{ t('candidates') }}</b-dropdown-item>
        <b-dropdown-item v-if="isClinic" :to="{ name: 'my-applications' }" v-tx="'HeaderMyApplications'">{{ t('myApplications') }}</b-dropdown-item>
        <b-dropdown-item v-if="isClinic" :to="{ name: 'clinic-nachrichten' }" v-tx="'HeaderMessages'">{{ t('messages') }}</b-dropdown-item>
        <b-dropdown-item v-if="isClinic" :to="{ name: 'clinic-settings' }" v-tx="'HeaderMyProfile'">{{ t('myProfile') }}</b-dropdown-item>
        <b-dropdown-item v-if="isNurse" :to="{ name: 'profile-nurse' }" v-tx="'HeaderMyCv'">{{ t('myCv') }}</b-dropdown-item>

        <b-dropdown-divider />
        <b-dropdown-item class="logout-item" @click="logout" v-tx="'HeaderLogout'">{{ t('logout') }}</b-dropdown-item>
      </b-dropdown>
    </div>
    <div class="header-right__auth" v-else>
      <router-link :to="{ name: 'login' }" class="auth-link" v-tx="'HeaderLogin'">{{ t('login') }}</router-link>
    </div>

    <button
      v-if="canEditStatics"
      type="button"
      class="edit-toggle"
      :class="{ active: editMode }"
      :title="editMode ? 'Edit mode aktiv' : 'Statik mətnləri redaktə et'"
      @click="toggleEdit"
    >
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M12 20h9"/>
        <path d="M16.5 3.5a2.121 2.121 0 1 1 3 3L7 19l-4 1 1-4z"/>
      </svg>
    </button>

    <div class="header-right__lang">
      <b-dropdown
        :text="active.toUpperCase()"
        class="lang-dropdown"
        toggle-class="lang-dropdown__button"
        no-caret
        size="sm"
        menu-class="lang-dropdown__menu"
      >
        <b-dropdown-item
          href="#"
          v-for="(item, index) in languages"
          :key="index"
          @click="changeLang(index)"
          :disabled="item.id == active"
          >{{ item.text }}</b-dropdown-item
        >
      </b-dropdown>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

const T = {
  az: { dashboard: "İdarə paneli", candidates: "Namizədlər", myApplications: "Müraciətlərim", messages: "Mesajlar", myProfile: "Profilim", myCv: "CV-m", logout: "Çıxış", login: "Daxil ol", roleClinic: "Klinika", roleNurse: "Tibb bacısı" },
  de: { dashboard: "Dashboard", candidates: "Kandidaten", myApplications: "Meine Bewerbungen", messages: "Nachrichten", myProfile: "Mein Profil", myCv: "Mein Lebenslauf", logout: "Abmelden", login: "Anmelden", roleClinic: "Klinik", roleNurse: "Pflegekraft" },
  en: { dashboard: "Dashboard", candidates: "Candidates", myApplications: "My applications", messages: "Messages", myProfile: "My profile", myCv: "My CV", logout: "Logout", login: "Log in", roleClinic: "Clinic", roleNurse: "Nurse" },
  ru: { dashboard: "Панель", candidates: "Кандидаты", myApplications: "Мои заявки", messages: "Сообщения", myProfile: "Мой профиль", myCv: "Моё резюме", logout: "Выйти", login: "Войти", roleClinic: "Клиника", roleNurse: "Медсестра" },
  tr: { dashboard: "Panel", candidates: "Adaylar", myApplications: "Başvurularım", messages: "Mesajlar", myProfile: "Profilim", myCv: "Özgeçmişim", logout: "Çıkış", login: "Giriş", roleClinic: "Klinik", roleNurse: "Hemşire" },
};

export default {
  data() {
    return {
      languages: [
        { id: "az", text: "AZ" },
        { id: "de", text: "DE" },
        { id: "en", text: "EN" },
        { id: "ru", text: "RU" },
        { id: "tr", text: "TR" },
      ],
    };
  },
  computed: {
    ...mapState({
      active: (state) => state.lang,
    }),
    isAuthenticated() { return this.$store.getters["auth/isAuthenticated"]; },
    isClinic() { return this.$store.getters["auth/isClinic"]; },
    isNurse() { return this.$store.getters["auth/isNurse"]; },
    email() { return this.$store.getters["auth/email"] || ""; },
    editMode() { return this.$store.state.editMode; },
    canEditStatics() {
      const allowed = ["qeybulla.aliverdev@gmail.com", "sakhavatra@code.edu.az"];
      return allowed.includes((this.email || "").toLowerCase());
    },
    initials() {
      const e = this.email;
      if (!e) return "?";
      const local = e.split("@")[0];
      const parts = local.split(/[._-]+/).filter(Boolean);
      if (parts.length >= 2) {
        return (parts[0][0] + parts[1][0]).toUpperCase();
      }
      return local.slice(0, 2).toUpperCase();
    },
    roleLabel() {
      if (this.isClinic) return this.t("roleClinic");
      if (this.isNurse) return this.t("roleNurse");
      return "";
    },
  },
  methods: {
    t(key) {
      const sKey = "Header" + key.charAt(0).toUpperCase() + key.slice(1);
      const ov = this.$store.state.statics && this.$store.state.statics[sKey];
      if (ov && String(ov).trim()) return ov;
      const lang = this.$store.state.lang || "az";
      const d = T[lang] || T.az;
      return d[key] != null ? d[key] : (T.az[key] || key);
    },
    changeLang(e) {
      this.$store.commit("setLangManual", this.languages[e].id);
    },
    logout() {
      this.$store.dispatch("auth/logout");
      this.$router.push({ name: "home" });
    },
    toggleEdit() {
      this.$store.commit("setEditMode", !this.editMode);
    },
  },
};
</script>

<style lang="scss" scoped>
.header-right { display: flex; align-items: center; gap: 0.75rem; }
.header-right__auth { display: flex; align-items: center;
  .auth-link { color: #1e3c72; text-decoration: none; font-weight: 600; font-size: 0.85rem; padding: 0.4rem 0.85rem; border: 1px solid #c5d2e8; border-radius: 8px;
    &:hover { background: #eef3fb; }
  }
}

.edit-toggle {
  display: inline-flex; align-items: center; justify-content: center;
  width: 32px; height: 32px; border-radius: 8px;
  background: #fff; color: #475569; border: 1px solid #d0d5dd; cursor: pointer; padding: 0;
  transition: background 0.12s, color 0.12s, border-color 0.12s;
  &:hover { background: #f1f6ff; color: #1e3c72; border-color: #c5d2e8; }
  &.active { background: #2a5298; color: #fff; border-color: #2a5298; }
}

.avatar {
  display: inline-flex; align-items: center; justify-content: center;
  width: 36px; height: 36px; border-radius: 50%;
  background: linear-gradient(135deg, #2a5298 0%, #1e3c72 100%);
  color: #fff; font-weight: 700; font-size: 0.82rem;
  letter-spacing: 0.5px; box-shadow: 0 2px 8px rgba(30, 60, 114, 0.25);
  transition: transform 0.15s, box-shadow 0.15s;
  &:hover { transform: translateY(-1px); box-shadow: 0 4px 12px rgba(30, 60, 114, 0.35); }
}
</style>

<style lang="scss">
/* unscoped — bootstrap-vue dropdown menu renders outside scoped scope */
.auth-dropdown__button {
  background: transparent !important;
  border: 0 !important;
  padding: 0 !important;
  box-shadow: none !important;
  &::after { display: none !important; }
  &:focus, &:active { box-shadow: 0 0 0 3px rgba(30, 60, 114, 0.2) !important; border-radius: 50% !important; }
}

.auth-dropdown__menu {
  min-width: 280px !important;
  padding: 0.4rem 0;
  margin-top: 0.6rem;
  border: 0;
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.18), 0 2px 8px rgba(15, 23, 42, 0.08);
  overflow: hidden;
  font-size: 0.9rem;

  > li.auth-dropdown__header {
    background: linear-gradient(135deg, #f1f6ff 0%, #ffffff 100%);
    border-bottom: 1px solid #eef0f4;
    padding: 0 !important;
    margin: 0 !important;

    > .b-dropdown-text {
      padding: 0 !important;
      margin: 0 !important;
      color: inherit;
    }
  }
  .auth-dropdown__header-row {
    display: flex;
    align-items: center;
    gap: 0.65rem;
    padding: 0.7rem 0.9rem;
  }
  .auth-dropdown__avatar-lg {
    width: 38px; height: 38px; border-radius: 50%;
    background: linear-gradient(135deg, #2a5298 0%, #1e3c72 100%);
    color: #fff; font-weight: 700; font-size: 0.85rem;
    display: flex; align-items: center; justify-content: center;
    letter-spacing: 0.5px;
    box-shadow: 0 2px 8px rgba(30, 60, 114, 0.3);
    flex-shrink: 0;
  }
  .auth-dropdown__info { display: flex; flex-direction: column; gap: 0.15rem; min-width: 0; flex: 1; overflow: hidden; }
  .auth-dropdown__email {
    font-size: 0.85rem; color: #1e3c72; font-weight: 600;
    overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
    line-height: 1.2;
  }
  .auth-dropdown__role {
    font-size: 0.68rem; color: #64748b; text-transform: uppercase; letter-spacing: 0.06em; font-weight: 600;
    line-height: 1.2;
  }

  .dropdown-divider { margin: 0.35rem 0; border-color: #eef0f4; }

  .dropdown-item {
    padding: 0.55rem 1rem;
    color: #1e3c72;
    font-size: 0.88rem;
    transition: background 0.12s;

    &:hover, &:focus { background: #f1f6ff; color: #1e3c72; }
    &:active { background: #2a5298; color: #fff; }
  }

  .logout-item .dropdown-item,
  .dropdown-item.logout-item {
    color: #c0392b;
    &:hover, &:focus { background: #fdecea; color: #c0392b; }
  }
}
</style>
